import PropTypes from 'prop-types';
import React, {Component} from 'react';
import { Row, Col, Badge } from 'reactstrap';
import {connect} from 'react-redux'
import { QueryInitialize_ACTION } from '../../Actions/LogisticActions';

var typingTimer;

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  render() {
    if(this.props.AddedSuccessfuly){
      typingTimer = setTimeout(() => this.props.Initialize(), 1600);
  }

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <div style = {{height:60, width: '100%'}}> 
          <h5 style = {{color:'#0099cc',borderBottom:1, borderBottomStyle:'dotted', borderBottomColor:'gray'}}>Action Log</h5>
          {this.props.Error ? 
                        <div>
                            <h4 style = {{color:'red', fontWeight:'bold'}}>{this.props.Error}</h4>
        </div> : <div />}
        {this.props.AddedSuccessfuly ? 
                        <div>
                            <h4 style = {{color:'green', fontWeight:'bold'}}>Success !</h4>
                      </div> : <div />}
      </div>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

function MapStateToProps(state) {
  return {
      AddedSuccessfuly: state.Query.AddedSuccessfuly,
      Error: state.Query.GeneralError,
}
}

const MapDispatchToProps = (dispatch) => {
  return {
      Initialize: () => {dispatch(QueryInitialize_ACTION())},
  }
}

export default connect(MapStateToProps, MapDispatchToProps)(DefaultFooter)